import { render } from "./warn3.vue?vue&type=template&id=8fb0acae&scoped=true"
import script from "./warn3.vue?vue&type=script&lang=js"
export * from "./warn3.vue?vue&type=script&lang=js"

import "./warn3.vue?vue&type=style&index=0&id=8fb0acae&lang=scss&scoped=true"
import "./warn3.vue?vue&type=style&index=1&id=8fb0acae&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb0acae"]])

export default __exports__